export const TAX_TYPE_OPTIONS = [
  { value: 'sales', label: 'Sales Tax' },
  { value: 'excise', label: 'Excise Tax' },
  { value: 'federal', label: 'Federal Tax' },
  { value: 'state', label: 'State Tax' },
]

export const TAX_AUTHORITY_OPTIONS = [
  { value: 'IRS', label: 'IRS' },
  { value: 'state', label: 'State Tax Authority' },
  { value: 'local', label: 'Local Tax Authority' },
]

export const BILLING_METHOD_OPTIONS = [
  { value: 'net', label: 'Net' },
  { value: 'gross', label: 'Gross' },
]

export const taxColumns = [
  { key: 'taxDescription', header: 'Tax Description', required: true, flex: '2.5' },
  { key: 'taxType', header: 'Tax Type', required: true, flex: '1.2' },
  { key: 'product', header: 'Product', required: false, flex: '1.5' },
  { key: 'taxAuthority', header: 'Tax Authority', required: false, flex: '1.2' },
  { key: 'amount', header: 'Amount', required: false, flex: '0.8' },
  { key: 'perUnit', header: 'Per Unit', required: false, flex: '1' },
  { key: 'total', header: 'Total', required: false, flex: '1' },
]
